export default "assets/images/73a7cee9434e8dd10a9d72296b9dc8f4.png";